// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../hooks/useQuoteContext'
// Component Imports
import HorizontalRule from '../ui-helper-elements/HorizontalRule'
import ResellerNonProfitDiscountRow from '../rows/reseller/ResellerNonProfitDiscountRow'
import ResellerMonthlyCustomerSoftwarePriceRow from '../rows/reseller/ResellerMonthlyCustomerSoftwarePriceRow'
import ResellerCorePEPMRow from '../rows/reseller/ResellerCorePEPMRow'
import ResellerPerformancePEPMRow from '../rows/reseller/ResellerPerformancePEPMRow'
import ResellerBenAdminPEPMRow from '../rows/reseller/ResellerBenAdminPEPMRow'
import ResellerTimeTrackingPEPMRow from '../rows/reseller/ResellerTimeTrackingPEPMRow'
import ResellerPrepayPriceRow from '../rows/reseller/ResellerPrepayPriceRow'
import ResellerImplementationRow from '../rows/reseller/ResellerImplementationRow'
import ResellerTotalsHeaderRow from '../rows/reseller/ResellerTotalsHeaderRow'
import ResellerPrepayTotal from '../rows/reseller/ResellerPrepayTotal'
import Spacer from '../ui-helper-elements/Spacer'
import SpacerThick from '../ui-helper-elements/SpacerThick'
import BottomToolbar from '../rows/misc/BottomToolbar'
import NotesRow from '../rows/misc/NotesRow'
// JS Imports
// Asset Imports

export default function ResellerSection({
   productPerformanceEECount,
   setProductPerformanceEECount,
   productTestAccount,
   setProductTestAccount,
}) {
   const state = useQuoteContext()
   const permissions = state.featurePermissions['ResellerSection']
   const permissionsForNotes = state.featurePermissions['NotesSection']

   if (permissions.includes(state.user_role) && state.discountReseller > 0) {
      return (
         <div>
            <HorizontalRule></HorizontalRule>
            <ResellerTotalsHeaderRow></ResellerTotalsHeaderRow>
            <ResellerCorePEPMRow></ResellerCorePEPMRow>
            <ResellerPerformancePEPMRow></ResellerPerformancePEPMRow>
            <ResellerTimeTrackingPEPMRow></ResellerTimeTrackingPEPMRow>
            <ResellerBenAdminPEPMRow></ResellerBenAdminPEPMRow>
            <ResellerNonProfitDiscountRow></ResellerNonProfitDiscountRow>
            <ResellerMonthlyCustomerSoftwarePriceRow></ResellerMonthlyCustomerSoftwarePriceRow>
            <Spacer></Spacer>
            <ResellerPrepayPriceRow></ResellerPrepayPriceRow>
            <ResellerPrepayTotal></ResellerPrepayTotal>
            <ResellerImplementationRow></ResellerImplementationRow>
            <SpacerThick></SpacerThick>
            <BottomToolbar
               productPerformanceEECount={productPerformanceEECount}
               setProductPerformanceEECount={setProductPerformanceEECount}
               productTestAccount={productTestAccount}
               setProductTestAccount={setProductTestAccount}
            />
         </div>
      )
   }
   return null
}
